import { render, staticRenderFns } from "./StoreClover.vue?vue&type=template&id=2b9bc0ef"
import script from "./StoreClover.vue?vue&type=script&lang=js"
export * from "./StoreClover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports